<template>
  <div class="page">


  <div style="position: relative;">
    <img
      src="http://kjsx.oss-cn-hangzhou.aliyuncs.com/post_content/202412241822003943.jpg"
    />
    <div
      style="position: absolute;top: 17%;left: 19%;width: 62%;height: 73%;display: flex;flex-wrap: wrap;"
    >
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1310"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1283"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1280"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1309"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1281"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1279"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
    </div>
  </div>

 <div style="position: relative;">
    <img
      src="http://kjsx.oss-cn-hangzhou.aliyuncs.com/post_content/202412241822229920.jpg"
    />
    <div
      style="position: absolute;top: 17%;left: 19%;width: 62%;height: 73%;display: flex;flex-wrap: wrap;"
    >
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1312"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1290"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1288"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1311"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1286"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1285"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
    </div>
  </div>


 <div style="position: relative;">
    <img
      src="http://kjsx.oss-cn-hangzhou.aliyuncs.com/post_content/202412241822261750.jpg"
    />
    <div
      style="position: absolute;top: 17%;left: 19%;width: 62%;height: 73%;display: flex;flex-wrap: wrap;"
    >
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1292"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1295"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1293"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1294"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1291"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1296"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
    </div>
  </div>



 <div style="position: relative;">
    <img
      src="http://kjsx.oss-cn-hangzhou.aliyuncs.com/post_content/202412241822306605.jpg"
    />
    <div
      style="position: absolute;top: 17%;left: 19%;width: 62%;height: 73%;display: flex;flex-wrap: wrap;"
    >
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1302"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1301"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1297"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1299"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1298"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1300"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
    </div>
  </div>

 <div style="position: relative;">
    <img
      src="http://kjsx.oss-cn-hangzhou.aliyuncs.com/post_content/202412241822346740.jpg"
    />
    <div
      style="position: absolute;top: 17%;left: 19%;width: 62%;height: 73%;display: flex;flex-wrap: wrap;"
    >
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1313"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1316"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1315"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1314"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1305"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
      <div style="width: 33%;height: 50%;">
        <a
          href="http://yingsai.xinzhidi.cn/detail?id=1306"  target="_blank"
          style="width: 100%;height: 100%;display: block;"
        ></a>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {}
};
</script>

<style></style>
<style scoped lang="scss">
.page {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
      position: relative;
}

img {
  width: 100%;
  display: block;
}

</style>
